import { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';

import { QueryParamsContext } from './queryParams.context';

export const QueryParamsProvider = ({ children }: { children: ReactNode }) => {
  const [serializedParams, setSerializedParams] = useState<string>(
    new URLSearchParams(window.location.search).toString(),
  );

  useEffect(() => {
    const handleUrlChange = () => {
      setSerializedParams(
        new URLSearchParams(window.location.search).toString(),
      );
    };

    window.addEventListener('popstate', handleUrlChange);
    return () => window.removeEventListener('popstate', handleUrlChange);
  }, []);

  const setParams = useCallback((newParams: URLSearchParams) => {
    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    window.history.pushState(null, '', newUrl);
    setSerializedParams(newParams.toString());
  }, []);

  const params = useMemo(
    () => new URLSearchParams(serializedParams),
    [serializedParams],
  );

  return (
    <QueryParamsContext.Provider value={{ params, setParams }}>
      {children}
    </QueryParamsContext.Provider>
  );
};
